import React from 'react'
import { Row, Col } from 'react-bootstrap'
import GoalCreator from './goalCreator/GoalCreator'
import InProgress from './inProgress/InProgress'
import Reached from './reached/Reached'

const Goals = () => {
  return (
    <Row>
      <Col>
        <GoalCreator />
      </Col>
      <Col>
        <InProgress />
      </Col>
      <Col>
        <Reached />
      </Col>
    </Row>
  )
}

export default Goals